import {
  signIn as apiSignIn,
  setAuthParams as apiSetAuthParams
} from '@/api/api'

export default {

  SIGN_IN: ({ commit, dispatch }, { email, password }) => {
    return apiSignIn({ username: email, password }).then(responseData => {
      commit('SET_TOKEN', { token: responseData.access_token })
      dispatch('SET_AUTH_PARAMS')
    }).catch(error => Promise.reject(error.response.data))
  },

  LOGOUT: ({ commit }) => {
    commit('SET_TOKEN', { token: null })
  },

  SET_AUTH_PARAMS: ({ getters }) => {
    if (!getters['IS_LOGGED']) return
    apiSetAuthParams({
      accessToken: getters['GET_TOKEN']
    })
  }
}
